import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { SosState } from './states'

const AdsAccount: Module<SosState, State> = {
  state: new SosState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default AdsAccount
